import React, { memo } from "react";

import { Card, Empty } from "antd";
import { Line } from "@ant-design/plots";
import { useQuery } from "@apollo/client";

import { isEqual } from "lodash";
import { SUBGRAPH_METRICS_QUERY } from "../../helpers/graphql/subgraph";

const Metrics: React.FC<any> = memo(
  ({ data, max, height }) => {
    const config = {
      data: data,
      smooth: true,
      xField: "timestamp",
      yField: "count",
      xAxis: {
        tickCount: 10,

        label: {
          formatter: (v: string) =>
            new Date(parseInt(v))
              .toISOString()
              .replace("T", " ")
              .split(".")[0]
              .slice(0, -3)
              .split(" ")[1],
        },
      },
      yAxis: {
        maxLimit: max,
      },
      tooltip: {
        showTitle: false,
        formatter: ({ timestamp, count }: any) => {
          return {
            name: new Date(timestamp).toISOString().replace("T", " ").split(".")[0].slice(0, -3),
            value: Intl.NumberFormat("en-US", {
              notation: "compact",
              maximumFractionDigits: 1,
            }).format(count),
          };
        },
      },
      slider: {
        start: 0.5,
        end: 1,
        formatter: (v: Date) =>
          new Date(v).toISOString().replace("T", " ").split(".")[0].slice(0, -3),
      },
    };
    return <Line {...config} height={height} />;
  },
  (pre, next) => {
    return isEqual(pre?.data, next?.data);
  },
);

export function SubgraphMetrics({ cluster, subgraphId, interval, showLast, height }: any) {
  const { loading, data } = useQuery(SUBGRAPH_METRICS_QUERY, {
    variables: { cluster , subgraphId, interval, showLast },
  });

  const subgraphMetrics =
    data?.subgraphMetrics.length > 0
      ? data?.subgraphMetrics
      : [
          {
            count: 0,
            timestamp: Date.now(),
          },
        ];

  return loading ? (
    <Card loading={true} className="card-loading" />
  ) : (
    <Card className={"card-body"} title="Request count">
      {subgraphMetrics && subgraphMetrics.length > 0 ? (
        <Metrics
          data={subgraphMetrics}
          max={subgraphMetrics && subgraphMetrics?.[0].count > 0 ? null : 4}
          height={height}
        />
      ) : (
        <Empty />
      )}
    </Card>
  );
}
